import { combineReducers } from 'redux';

import auth from './auth/reducer';
import user from './user/reducer';
import lifecycle from './lifecycle/reducer';

export default combineReducers({
  auth,
  user,
  lifecycle,
});
